<template lang="pug">
div
  el-row(:gutter="10")
    el-col(:lg="8", :md="8", :sm="24")
      p.label Tipo do processo:
      el-select(
        planceholder="Selecione",
        v-model="filtro.tipo",
        no-match-text="Nenhum Tipo Encontrado",
        filterable,
        clearable
      )
        el-option(
          v-for="item in tiposProcesso",
          :key="item.id",
          :label="item.nome",
          :value="item.codigo",
        )
    el-col(v-if="!isMA" :lg="8", :md="8", :sm="24")
      p.label Status:
      el-select(
        planceholder="Selecione"
        no-match-text="Nenhum Status Encontrado",
        v-model="filtro.status",
        filterable,
        clearable
      )
         el-option(
          v-for="item in statusCadastro",
          :key="item",
          :label="getStatusFormatado(item)",
          :value="item",
        )
    el-col(:lg="8", :md="8", :sm="24")
      p.label Município:
      el-select(
        planceholder="Selecione"
        no-match-text="Nenhum Status Encontrado",
        v-model="filtro.municipio",
        filterable,
        clearable
        @clear="resetFilter"
      )
        el-option(
          v-for="item in municipios",
          :key="item.id",
          :label="item.nome",
          :value="item.id",
        )
  el-row(:gutter="10")
    el-col(:lg="8", :md="12", :sm="24")
      p.label Nº do processo:

      el-input(
        v-mask="['#########/####']",
        v-model="filtro.numeroProcesso"
      )
    el-col(:lg="8", :md="12", :sm="24")
      p.label {{ isIcmBio ? 'CPF/CNPJ do interessado ou número do CNUC:' : 'CPF/CNPJ do interessado:' }}
      el-input(
        v-mask="['###.###.###-##', '##.###.###/####-##']",
        v-model="filtro.cpfCnpj"
      )
    el-col(:span="24")
      p.label {{ isIcmBio ? 'Nome/Razão Social do Interessado ou nome da Unidade de Conservação:' : 'Nome/Razão social do interessado:' }}
      el-input(v-model="filtro.nomeRazaoSocial")
  el-row.button-row
    p.observacao(v-if="EXIBIR_OBSERVACAO_CONSULTA_PROCESSOS")
      span.atencao *
      i Essa área de consulta é exclusiva para processos eletrônicos do SiCARF. Caso o seu
        |  ainda seja físico, você deverá acessar:
        a.url(
          href="http://www.iterpa.pa.gov.br/content/consulta-de-processos"
          target="_blank")  iterpa.pa.gov.br/content/consulta-de-processos
    span.limpar(@click="limpar") Limpar
    el-button(type="primary", @click="consultar")
      i.icon(class="fas fa-search")
      | Consultar
  el-row
    listagem-processos(
      :processos="processos",
      :totalItems.sync="countProcessos",
      @changePage="changePage",
      :page="filtro.pagina",
      :loading="loadingTable",
      @goTo='goTo'
    )
    el-button.right(
      type="text",
      @click="exportarCsv",
      :disabled="disableExportarCSV",
    )
      i.fal.fa-file-csv
      | &nbsp Exportar CSV

</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex'
import ListagemProcessos from '@/screens/portal/publico/components/ListagemProcessos'
import EnumFormatter from '@/utils/EnumFormatter'
import AppNotificacao from '@/components/mixins/AppNotificacao'

export default {
  components: {
    ListagemProcessos
  },

  mixins: [
    AppNotificacao
  ],

  data () {
    return {
      filtro: {
        pagina: 1,
        simplificado: false
      },
      processos: [],
      countProcessos: 0,
      loadingTable: false,
      disableExportarCSV: true,
      isMA: process.env.ESTADO === 'ma'
    }
  },
  created () {
    this.clearProcessos()
    this.getTiposProcesso()
    this.getStatusCadastro()
    this.getMunicipiosByEstadoAtual()
    this.consultar()
  },
  computed: {
    ...mapGetters({
      tiposProcesso: 'processos/tiposProcessos',
      statusCadastro: 'processos/statusProcessos',
      filtroProcessos: 'processos/filtroProcessos',
      municipios: 'municipiosPortal/municipios'
    }),

    ...mapState({
      EXIBIR_OBSERVACAO_CONSULTA_PROCESSOS: state => state.userInterface.dadosEstado.PUBLICO.EXIBIR_OBSERVACAO_CONSULTA_PROCESSOS
    }),

    isIcmBio () {
      return process.env.ESTADO === 'default'
    }
  },
  methods: {
    ...mapActions({
      getTiposProcesso: 'processos/getTiposProcessos',
      getStatusCadastro: 'processos/getStatus',
      getProcessos: 'processos/getProcessosByFilterConsulta',
      clearProcessos: 'processos/clearProcesso',
      baixarCsv: 'processos/getCsvProcessosPublico',
      getMunicipiosByEstadoAtual: 'municipiosPortal/findMunicipiosByEstadoAtual'
    }),

    async consultar () {
      this.loadingTable = true
      this.filtro.pagina = 1
      this.ajustObject()
      const response = await this.getProcessos(this.filtro)
      if (this.isMA) {
        this.processos = response.processosConsulta
      } else {
        this.processos = response.processos
      }
      this.countProcessos = response.total
      this.loadingTable = false
    },

    limpar () {
      this.filtro = {
        pagina: 1,
        simplificado: false
      }
      this.changePage(1)
    },

    ajustObject () {
      for (var index in this.filtro) {
        if (this.filtro[index] === '') {
          delete this.filtro[index]
        }
      }
    },

    async changePage (newPage) {
      this.filtro.pagina = newPage
      const response = await this.getProcessos(this.filtro)
      if (this.isMA) {
        this.processos = response.processosConsulta
      } else {
        this.processos = response.processos
      }
      this.countProcessos = response.total
    },

    getTipoFormatado (codigo) {
      return EnumFormatter.getTipoFormatado(codigo)
    },

    getStatusFormatado (codigo) {
      return EnumFormatter.getStatusFormatado(codigo)
    },

    // Exporta csv com os dados buscado de acordo com o filtro escolhido
    exportarCsv () {
      this.baixarCsv(this.filtro)
    },

    formatedDate () {
      const date = new Date()
      const data = ((date.getDate() < 10) ? '0' : '') + date.getDate() +
        '_' + (((date.getMonth() + 1) < 10) ? '0' : '') + (date.getMonth() + 1) +
        '_' + date.getFullYear()
      const hora = ((date.getHours() < 10) ? '0' : '') + date.getHours() +
        '_' + ((date.getMinutes() < 10) ? '0' : '') + date.getMinutes() +
        '_' + ((date.getSeconds() < 10) ? '0' : '') + date.getSeconds()
      return '_' + data + '_' + hora
    },

    resetFilter () {
      this.filtro.municipio = null
    },
    goTo (data, setLoader, resetLoader) {
      setLoader()
      this.$router.push({
        name: 'detalhes-processo',
        params: {
          idCadastro: data.numeroProtocolo,
          numeroProcesso: data.numeroProcesso,
          id: data.id
        }
      }, () => {
        resetLoader()
      })
    }
  },
  watch: {
    countProcessos (value) {
      this.disableExportarCSV = !(value > 0)
    }
  }
}
</script>
<style lang="scss">
@import '@/assets/styles/element-variables.scss';

.url {
  color: #009f61;
  text-decoration: none;
  font-weight: bold;
}

.limpar {
  margin-right: 20px;
  color: $--color-primary;
  cursor: pointer;
  &:hover {
    font-weight: bold;
  }
}
.icon {
  margin-right: 7px;
}
.el-select {
  width: 100%;
}
.label {
  margin: 0;
  padding: 12px 0 8px 0px;
}
.button-row {
  margin-top: 10px;
  text-align: right;
}
.right {
  float: right;
  cursor: pointer;
  margin: 10px 0px;
}
.observacao {
  float: left;
}
.atencao {
  color: red;
}
</style>



// WEBPACK FOOTER //
// src/screens/portal/publico/ConsultaGeral.vue